import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flex h-max"
  }, [_vm._m(0), _c('div', {
    staticClass: "icons flex1"
  }, _vm._l(_vm.legends, function (it) {
    return _c('div', {
      key: it.key,
      staticClass: "icon"
    }, [_c('div', [_vm._v(_vm._s(it.name))]), _c('div', {
      staticClass: "img",
      class: it.key
    })]);
  }), 0)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "echarts flex1"
  }, [_c('div', {
    staticClass: "h-max",
    attrs: {
      "id": "MIDivision"
    }
  })]);
}];
export { render, staticRenderFns };